module.exports = __webpack_public_path__ + "static/media/entregapapas.cb863a88.jpg";